// TODO: Migrate to V2
import { ReactNode } from 'react'
import { Image } from 'semantic-ui-react'
import styles from './styles.module.scss'
import { Text } from '@/base'

export const LandingPage = ({
  children,
  imageAlt,
  imageSrc,
  imageHeight,
  imageWidth,
  kickerText,
  title,
}: {
  children?: ReactNode
  imageAlt: string
  imageSrc: string
  imageHeight: number
  imageWidth: number
  kickerText?: ReactNode
  title: string
}) => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      <Image
        src={imageSrc}
        alt={imageAlt}
        width={imageWidth}
        height={imageHeight}
      />
    </div>

    {kickerText && <text>{kickerText}</text>}
    <Text as="display2">{title}</Text>

    {children}
  </div>
)
